// extracted by mini-css-extract-plugin
export default {"container":"container__ZpFX-","number":"number__WV2t2","komma":"komma__zlHmN","unit":"unit__ad0sG"};